<template>
  <span class="quick-search">
    <span>{{ $t('home.quickSearch') }}</span>
    <div class="search-field" style="margin-top:10px">
      <i class="el-icon-shopping-cart-2" style="margin-bottom:3px;margin-right:5px" />
      <span class="search-span">{{ $t('orderLine.ticketNumber') }}</span>
      <el-input
        v-model="ticketNumber"
        class="search-input"
        :disabled="customerReference.length > 0 || barcode.length > 0"
        :placeholder="$t('orderLine.ticketNumber')"
        name="ticketNumber"
        type="text"
        @keyup.enter.native="searchOrderLine"
      />
    </div>
    <div class="search-field">
      <i class="el-icon-shopping-cart-2" style="margin-bottom:3px;margin-right:5px" />
      <span class="search-span">{{ $t('orderLine.customerReference') }}</span>
      <el-input
        v-model="customerReference"
        class="search-input"
        :disabled="ticketNumber.length > 0 || barcode.length > 0"
        :placeholder="$t('orderLine.customerReference')"
        name="customerReference"
        type="text"
        @keyup.enter.native="searchOrderLine"
      />
    </div>
    <div class="search-field">
      <i class="el-icon-shopping-cart-2" style="margin-bottom:3px;margin-right:5px" />
      <span class="search-span">{{ $t('common.ticketBarcode') }}</span>
      <el-input
        v-model="barcode"
        class="search-input"
        :disabled="ticketNumber.length > 0 || customerReference.length > 0"
        :placeholder="$t('common.ticketBarcode')"
        name="barcode"
        type="text"
        minlength="13"
        maxlength="13"
        show-word-limit
        @keyup.enter.native="searchOrderLine"
      />
    </div>
    <div class="search-field">
      <i class="el-icon-user" style="margin-bottom:3px;margin-right:5px" />
      <span class="search-span">{{ $t('store.name') }}</span>
      <el-autocomplete
        v-model="storeName"
        :disabled="storeCode.length > 0"
        :fetch-suggestions="getStoreSuggestions"
        :placeholder="$t('store.name')"
        style="width:100%"
        @select="handleStoreSelected"
      ></el-autocomplete>
    </div>
    <div class="search-field">
      <i class="el-icon-user" style="margin-bottom:3px;margin-right:5px" />
      <span class="search-span">{{ $t('store.code') }}</span>
      <el-autocomplete
        v-model="storeCode"
        :disabled="storeName.length > 0"
        :fetch-suggestions="getStoreSuggestions"
        :placeholder="$t('store.code')"
        style="width:100%"
        @select="handleStoreSelected"
      ></el-autocomplete>
    </div>
  </span>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      barcode: '',
      currentRole: 'visitorHome',
      ticketNumber: '',
      customerReference: '',
      storeName: '',
      storeCode: ''
    };
  },
  computed: {},
  created() {
    if (this.userId) {
      this.currentRole = 'memberHome';
    } else {
      this.currentRole = 'visitorHome';
    }
  },
  methods: {
    getStoreSuggestions(queryString, cb) {
      this.$store
        .dispatch('store/getSuggestions', { storeName: this.storeName, storeCode: this.storeCode })
        .then(data => {
          const suggestions = data.map(i => {
            return {
              clientID: i.clientID,
              domainID: i.domainID,
              storeID: i.storeID,
              value: i.clientName + ' - ' + i.code + ', ' + i.name
            };
          });
          cb(suggestions);
        });
    },
    handleStoreSelected(item) {
      this.$router.push({
        name: 'EditStore',
        params: { clientID: item.clientID, domainID: item.domainID, id: item.storeID }
      });
    },
    searchOrderLine() {
      if (this.barcode) {
        this.getOrderLineIdByBarcode();
      } else {
        this.$store
          .dispatch('orderLine/quickSearch', {
            ticketNumber: this.ticketNumber,
            customerReference: this.customerReference
          })
          .then(id => {
            if (id) {
              this.$router.push({ name: 'EditOrderLine', params: { id } });
            } else {
              this.$router.push({
                name: 'OrderLines',
                params: {
                  filters: {
                    ticketNumber: this.ticketNumber,
                    customerReference: this.customerReference
                  }
                }
              });
            }
          });
      }
    },
    getOrderLineIdByBarcode() {
      this.$store
        .dispatch('orderLine/getByBarcode', {
          barcode: this.barcode
        })
        .then(id => {
          if (id) {
            this.$router.push({ name: 'EditOrderLine', params: { id } });
          } else {
            this.$store.dispatch('notify/error', { message: this.$i18n.t('common.ticketBarcodeNotFound') });
          }
        });
    }
  }
};
</script>

<style>
.el-autocomplete-suggestion li {
  font-size: 12px !important;
  font-family: Arial, sans-serif !important;
}

.search-span {
  font-size: 14px;
}

.search-field {
  padding-bottom: 10px;
}

.search-input {
  padding-top: 4px;
}
</style>
